import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { brand } from '../data/site';
import { usePrefersReducedMotion } from '../hooks/useMedia';
const SESSION_KEY = 'morvix-intro-seen';

/** Short typographic intro. Plays once per session, skipped for reduced-motion. */
export function LoadingScreen() {
  const reduced = usePrefersReducedMotion();
  const [visible, setVisible] = useState(() => {
    if (typeof window === 'undefined') return false;
    try {
      return window.sessionStorage.getItem(SESSION_KEY) !== '1';
    } catch {
      return true;
    }
  });
  useEffect(() => {
    if (!visible) return;
    if (reduced) {
      setVisible(false);
      return;
    }
    document.body.style.overflow = 'hidden';
    const timer = window.setTimeout(() => setVisible(false), 1650);
    return () => {
      window.clearTimeout(timer);
      document.body.style.overflow = '';
    };
  }, [visible, reduced]);
  useEffect(() => {
    if (visible) return;
    document.body.style.overflow = '';
    try {
      window.sessionStorage.setItem(SESSION_KEY, '1');
    } catch {
      /* ignore */
    }
  }, [visible]);
  const word = 'MORVIX';
  return <AnimatePresence data-id="element-314" data-mp="27h1wxxnz8s8y">
      {visible ? <motion.div className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#06060A]" exit={{
      y: '-100%'
    }} transition={{
      duration: 0.85,
      ease: [0.76, 0, 0.24, 1]
    }} aria-hidden="true" data-id="element-315" data-mp="27fz8dwe4n1w7">
          <div className="flex overflow-hidden" data-id="element-316" data-mp="22hfmfvzj9q3u">
            {word.split('').map((letter, index) => <motion.span key={`${letter}-${index}`} className="font-display text-[15vw] font-extrabold leading-none tracking-tightest text-white sm:text-[9vw]" initial={{
          y: '110%'
        }} animate={{
          y: '0%'
        }} transition={{
          duration: 0.8,
          delay: 0.05 * index,
          ease: [0.16, 1, 0.3, 1]
        }} data-id="element-317" data-mp="1oifuofgq4v3g" data-mpi={index}>
                {letter}
              </motion.span>)}
          </div>
          <motion.div className="mt-6 h-px bg-brand" initial={{
        width: 0
      }} animate={{
        width: '38vw'
      }} transition={{
        duration: 1.1,
        ease: [0.16, 1, 0.3, 1]
      }} data-id="element-318" data-mp="3mbs3sivgg5zj" />
          <motion.p className="label mt-6 text-lav" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.5,
        duration: 0.6
      }} data-id="element-319" data-mp="37glyjy46ob79">
            {brand.tagline}
          </motion.p>
        </motion.div> : null}
    </AnimatePresence>;
}